import classnames from "classnames";
import Certifiacte from "nvent-web/assets/svg/certificate.svg";
import TwentyYears from "nvent-web/assets/svg/20_years.svg";
import Website from "nvent-web/assets/svg/website.svg";
import Promotions from "nvent-web/assets/svg/promotions.svg";
import Events from "nvent-web/assets/svg/events.svg";
import News from "nvent-web/assets/svg/news.svg";

import styles from "./BenefitIcon.module.scss";

const benefitIcons = {
  TwentyYears,
  Website,
  Promotions,
  Events,
  Certifiacte,
  News,
} as const;

const borderRadiuses = {
  md: "24px",
  sm: "12px",
} as const;

export const BenefitIcon = ({
  icon,
  borderRadius = "md",
  className,
}: {
  icon: keyof typeof benefitIcons;
  borderRadius?: keyof typeof borderRadiuses;
  className?: string;
}) => (
  <div
    className={classnames(styles.iconWrapper, className)}
    style={{ borderRadius: borderRadiuses[borderRadius] }}
  >
    <img
      className={styles.icon}
      src={benefitIcons[icon]}
      aria-hidden={true}
      loading="lazy"
    />
  </div>
);
